import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },
  map: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 74,
  },
  marker: {
    width: 64,
    height: 50,
    marginTop: -50,
    marginLeft: 15,
  },
  savePointsContainer: {
    position: "absolute",
    bottom: 8,
    left: 8,
    width: 100,
    height: 48,
  },
  card: {
    position: "absolute",
    bottom: 8,
    left: 8,
    width: 320,
    height: 100,
    backgroundColor: "#fff",
    borderRadius: 8,
  },
  input: {
    height: 48,
    textAlign: "right",
    borderBottomWidth: 2,
    borderBottomColor: "#ccc",
    padding: 8,
    marginBottom: 8,
    fontFamily: "Vazir",
    fontSize: 16,
  },
  input_error: {
    borderBottomColor: "red",
  },
});

export default styles;
